/**
 * The origin story, told as staggered beats that reveal on scroll
 * (`storySection` in `sections.ts` renders this list into the timeline).
 * Kept separate from `copy.ts` so the narrative can be rewritten without
 * touching feature/footer/bestiary copy.
 */

export interface StoryBeat {
  readonly lead: string;
  readonly body: string;
}

export const STORY_BEATS: readonly StoryBeat[] = [
  {
    lead: '2076. The year the machines learned to answer almost everything.',
    body: 'One question was left: whether a person could travel through time. An engineer built a machine to find out — a short hop, a few minutes back, nothing that could go wrong. It worked, again and again, on animals sent through and recovered safe.',
  },
  {
    lead: 'It worked on him too. Just not the way he built it.',
    body: 'The capsule — ORPHEUS — malfunctioned mid-jump. Instead of minutes, it threw him sixty-six million years: past the rise of everything he knew, into the last dawn of the Cretaceous.',
  },
  {
    lead: 'The capsule survived the fall. Its cores did not stay put.',
    body: 'ORPHEUS lies cracked open in the floodplain mud, its four power cores thrown wide across the delta — one to a compass point, each one guarded by something that already lives here.',
  },
  {
    lead: 'A red sun. A second light rising to meet it.',
    body: 'This is the day it all ends for everything on this floodplain — the morning Chicxulub arrives — and a man sixty-six million years from home is standing in it, with no way back but the machine he broke.',
  },
  {
    lead: 'You are not the hunter here.',
    body: 'No weapons. The floodplain is faster than you, and things in the treeline, the shallows, and the sky are already listening. Crouch to break line of sight. Move slow. Read the wildlife before it reads you.',
  },
  {
    lead: 'Recover the cores. Charge the jump. Outrun the sky.',
    body: 'One core at a time, carried back to the capsule by hand from each of the four guarded sites. Seat all four, hold position while ORPHEUS charges — and be gone before the impact finds you too.',
  },
];
